import { render, staticRenderFns } from "./list.vue?vue&type=template&id=9b2e67c4&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=9b2e67c4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2e67c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b2e67c4')) {
      api.createRecord('9b2e67c4', component.options)
    } else {
      api.reload('9b2e67c4', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=9b2e67c4&scoped=true", function () {
      api.rerender('9b2e67c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/platformManagement/accountManagement/accountNumManagement/list.vue"
export default component.exports